import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Events = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-sky-50">
      <Header />
      
      <main className="container mx-auto px-4 pt-32 pb-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Upcoming Events
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Join us for workshops, demos, and networking opportunities designed to help caregivers maximize their tax benefits
          </p>
        </div>

        <div className="flex justify-center">
          <iframe
            src="https://luma.com/embed/calendar/cal-4uZSHyBwrUCFDUi/events"
            width="600"
            height="450"
            style={{ border: '1px solid #bfcbda88', borderRadius: '4px', maxWidth: '100%' }}
            allowFullScreen
            aria-hidden="false"
            tabIndex={0}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Events;
